module.exports = __webpack_public_path__ + "static/30th-84569f319f0ddce58dc2de4696feeab4.gif";